import T from "i18n-react";

export function localesInit() {
    let language = (navigator.languages?.[0]) || navigator.language || navigator.userLanguage;
    if (language.length > 2) {
        language = language.split("-")[0];
        language = language.split("_")[0];
    }
    try {
        T.setTexts(require(`./${language}.json`));
    } catch (err) {
        T.setTexts(require(`./en.json`));
    }
}
